// Inventario de módulos de permission_default — compartido entre la pantalla de defaults
// (usePermissionsList.js) y la de overrides por worker. Única fuente de verdad de qué
// módulos existen, cómo se llaman en el menú y bajo qué sección viven.

// i18n keys exactamente como están declaradas en src/navigation/vertical/*.js (item.title /
// item.header) — NO texto pre-traducido. Resolviéndolas con $t() en cada pantalla (mismo
// patrón que usan los componentes de nav) garantiza que esto siempre coincida con lo que
// el usuario ve en el sidebar, en cualquier idioma activo. El moduleKey queda como dato
// técnico secundario debajo.
export const MODULE_NAV_KEYS = {
  'privacy-indicators': { key: 'Indicators' },
  'privacy-treatment': { key: 'Treatments' },
  'privacy-inherent-risk': { parentKey: 'Treatments', key: 'Inherent Risk Analysis' },
  'privacy-residual-risk': { parentKey: 'Treatments', key: 'Residual Risk Analysis' },
  'privacy-gap': { key: 'Gaps' },
  'privacy-risk-map': { key: 'Risks Map' },
  'privacy-arsopbl-follow-up': { parentKey: 'ARSOPB+L Channel', key: 'New/State' },
  'privacy-arsopbl-list': { parentKey: 'ARSOPB+L Channel', key: 'List' },
  'privacy-arsopbl-templates': { parentKey: 'ARSOPB+L Channel', key: 'Response Templates' },
  'general-dashboard': { key: 'General' },
  'confirmations-global': { parentKey: 'Confirmations', key: 'Global' },
  'confirmations-daily': { parentKey: 'Confirmations', key: 'Daily' },
  'adherence-processes': { parentKey: 'Adherence', key: 'Processes' },
  'adherence-behaviours': { parentKey: 'Adherence', key: 'Behaviours' },
  'adherence-improvement': { parentKey: 'Adherence', key: 'Continuous Improvement' },
  'case-management': { key: 'Case Management' },
  risks: { key: 'Risks' },
  controls: { parentKey: 'Risks', key: 'Controls' },
  'task-behaviours': { parentKey: 'Risks', key: 'Behaviours' },
  calendar: { key: 'Calendar' },
  'pending-confirmations': { parentKey: 'Calendar', key: 'Pending Confirmations' },
  'confirmation-planning': { key: 'Confirmation Planning' },
  'complaint-channel': { parentKey: 'Complaint Channel', key: 'List' },
  'complaint-follow-up': { parentKey: 'Complaint Channel', key: 'New/State' },
  'records-library': { parentKey: 'Records', key: 'Library' },
  'records-coi-collaborator': { parentKey: 'Records', key: 'Confl. of Interest Collaborator' },
  'records-coi-supplier': { parentKey: 'Records', key: 'Confl. of Interest Supplier' },
  'records-lobby': { parentKey: 'Records', key: 'Terceros - Relacionamiento' },
  'organization-workers': { parentKey: 'Organization_', key: 'Users' },
  'organization-locations': { parentKey: 'Organization_', key: 'Locations' },
  'organization-roles': { parentKey: 'Organization_', key: 'Roles' },
  'organization-companies': { parentKey: 'Organization_', key: 'Companies' },
  'organization-ids': { parentKey: 'Organization_', key: 'IDs' },
  crimes: { key: 'Crimes' },
  settings: { key: 'Settings' },
  help: { key: 'Help' },
}

// Header (sección) donde vive cada módulo en src/navigation/vertical/index.js — mismo orden
// en que se arman las secciones ahí (privacy, pcDashboards, task, organization, settings).
export const HEADER_ORDER = ['Privacy', 'PC Dashboards', 'Tasks', 'Organization', 'Configuration']

export const MODULE_HEADER_KEYS = {
  'privacy-indicators': 'Privacy',
  'privacy-treatment': 'Privacy',
  'privacy-inherent-risk': 'Privacy',
  'privacy-residual-risk': 'Privacy',
  'privacy-gap': 'Privacy',
  'privacy-risk-map': 'Privacy',
  'privacy-arsopbl-follow-up': 'Privacy',
  'privacy-arsopbl-list': 'Privacy',
  'privacy-arsopbl-templates': 'Privacy',
  'general-dashboard': 'PC Dashboards',
  'confirmations-global': 'PC Dashboards',
  'confirmations-daily': 'PC Dashboards',
  'adherence-processes': 'PC Dashboards',
  'adherence-behaviours': 'PC Dashboards',
  'adherence-improvement': 'PC Dashboards',
  'case-management': 'PC Dashboards',
  risks: 'Tasks',
  controls: 'Tasks',
  'task-behaviours': 'Tasks',
  calendar: 'Tasks',
  'pending-confirmations': 'Tasks',
  'confirmation-planning': 'Tasks',
  'complaint-channel': 'Organization',
  'complaint-follow-up': 'Organization',
  'records-library': 'Organization',
  'records-coi-collaborator': 'Organization',
  'records-coi-supplier': 'Organization',
  'records-lobby': 'Organization',
  'organization-workers': 'Organization',
  'organization-locations': 'Organization',
  'organization-roles': 'Organization',
  'organization-companies': 'Organization',
  'organization-ids': 'Organization',
  crimes: 'Organization',
  settings: 'Configuration',
  help: 'Configuration',
}

// Las 5 acciones que la UI siempre muestra, aunque hoy solo view/edit existan en la base —
// create/export/delete se ven destildadas (no definidas aún) hasta que se siembren.
export const ACTIONS = ['view', 'edit', 'create', 'export', 'delete']
